import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@adc/ui-core'
import classnames from 'classnames/bind'
import CoBuyerFormWrapper from '../coBuyerFormWrapper'
import { MoreBuyersCheckbox } from '../internal'
import { MAX_COBUYERS } from '../constants'
import styles from './styles.scss'
const cx = classnames.bind(styles)

class MultiCoBuyer extends Component {
  static propTypes = {
    fields: PropTypes.any,
    isAutoCapitalize: PropTypes.bool,
  }

  static defaultProps = {
    showTitlesOnly: false,
  }

  state = {
    closeConfirmationModalOpen: false,
    contentOpened: false,
    openedModalIndex: null,
  }

  onAddCoBuyer = e => {
    // button clicks trigger form submit
    e.preventDefault()
    e.stopPropagation()
    this.props.fields.push({})
  }

  onCoBuyerClose = index => {
    this.props.fields.remove(index)
  }

  renderCoBuyerForms = () => {
    const { fields, isAutoCapitalize } = this.props

    return (
      <div>
        {fields.map((formKey, index, fields) => (
          <div key={index}>
            <CoBuyerFormWrapper
              fields={fields}
              formKey={formKey}
              index={index}
              key={index}
              onCoBuyerClose={this.onCoBuyerClose}
              isAutoCapitalize={isAutoCapitalize}
            />
          </div>
        ))}
      </div>
    )
  }

  renderAddComponent = () => {
    return (
      <div className={cx('add-more-button', 'u-mt-2')}>
        <Button elmId='add_co_buyer' role='primary' onClick={this.onAddCoBuyer}>
          Add Co-Buyer (Max. 3)
        </Button>
      </div>
    )
  }

  render() {
    const { fields } = this.props
    if (fields.length === 0) {
      fields.push({})
    }

    return (
      <div>
        <div>{this.renderCoBuyerForms()}</div>
        {fields.length < MAX_COBUYERS && this.renderAddComponent()}
        {fields.length === MAX_COBUYERS && <MoreBuyersCheckbox />}
      </div>
    )
  }
}

export default MultiCoBuyer
